import {observable, runInAction} from "mobx";
import api from "../../Services/Api";

class SettingsPageStore {
    @observable pinCode: string = '';
    @observable requirePinForSettingsChange: boolean = false;
    @observable hasChanges: boolean = false;

    async save() {
        if (!this.canSave) {
            return;
        }
        
        const result = await api.post("user/saveSettings", {
            pinCode: this.pinCode,
            requirePinForSettingsChange: this.requirePinForSettingsChange
        });
        if (result.success) {
            runInAction(() => {
                this.hasChanges = false;
                void this.load();
            });
        }
    }

    async load() {
        const result = await api.get("user/settings");
        if (result.success) {
            if (result.data.pinCode) {
                runInAction(() => {
                    this.pinCode = result.data.pinCode;
                    this.requirePinForSettingsChange = true;
                });
            }
        }
    }

    setPinCode(pinCode: string) {
        this.pinCode = pinCode;
        this.hasChanges = true;
    }

    setRequirePinForSettingsChange(value: boolean) {
        this.requirePinForSettingsChange = value;
        this.hasChanges = true;
    }

    get canSave(): boolean {
        if (!this.hasChanges) {
            return false;
        }
        if (!this.requirePinForSettingsChange) {
            return true;
        }

        return this.pinCode.length >= 4 && this.pinCode.length <= 16;
    }
    
    cleanup() {
        this.pinCode = '';
        this.requirePinForSettingsChange = false;
        this.hasChanges = false;
    }
}

const settingsPageStore = new SettingsPageStore();
export default settingsPageStore;